import { useTranslation } from 'react-i18next';

export const useNavItemList = () => {
    const { t } = useTranslation();
    return [
        { name: t('machines.c120'), url: "/machines/C120" },
        { name: t('machines.p2_1'), url: "/machines/P2_1" },
        { name: t('machines.p2_2'), url: "/machines/P2_2" },
        { name: t('machines.p4l'), url: "/machines/P4L" },
        { name: t('machines.primaPower'), url: "/machines/PrimaPower1" },
        { name: t('machines.primaPower2'), url: "/machines/PrimaPower2" },
        { name: t('machines.s2'), url: "/machines/S2" },
        { name: t('machines.s4p4'), url: "/machines/S4P4" },
        { name: t('machines.s4xe'), url: "/machines/S4Xe" },
        { name: t('machines.s4xep4'), url: "/machines/S4XeP4" },
        { name: t('machines.tc1000'), url: "/machines/TC1000" },
        { name: t('machines.tc3000r'), url: "/machines/TC3000R" },
        { name: t('machines.truPunch5000'), url: "/machines/TruPunch5000" },
        { name: t('machines.truBend7030'), url: "/machines/TruBend7030" },
    ];
};

export const useTabbarButtonsNavList = () => {
    const { t } = useTranslation();
    return [
        { name: t('navbar.dashboard'), url: "/dashboard" },
        { name: t('navbar.machines'), url: "/machines" },
        // { name: t('navbar.support'), url: "/support" },
        { name: t('navbar.upload'), url: "/upload" },
        { name: t('navbar.dataEntry'), url: "/veri-girisi" },
        { name: t('navbar.constraint'), url: "/constraint" },
        { name: t('navbar.oee'), url: "/oee" },
    ];
};